import Typography from "@mui/material/Typography";
import type { JSX } from "react";

interface ParameterLineProps {
  name: string;
  value: string;
}

/**
 * Строка «параметр — значение» с выделенным названием параметра. Живёт в
 * дизайн-системе, чтобы блоки параметров на всех экранах читались одинаково.
 */
export function ParameterLine(props: ParameterLineProps): JSX.Element {
  return (
    <Typography variant="body2">
      <strong>{props.name}:</strong> {props.value}
    </Typography>
  );
}
